{
  "modal": {
    "title": "Reserve",
    "recurringReservation": "Regular slot",
    "singleReservation": "Single slot",
    "saunaRulesLink": "Rules",
    "commonAreaRulesLink": "Rules",
    "commonAreaTermsLink": "Reservation terms",
    "acceptRules": "I accept rules and reservation terms",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "reserveButton": "Reserve",
    "paymentButton": "Pay",
    "reservationLimitWarning": "You have reached the maximum number of bookings. If you want to change your booking, please cancel your current reservation first.",
    "sendConfirmationEmail": "Send confirmation message to my email",
    "confirmationEmailOffWarningFree": "You will find reservation details on the resident pages.",
    "confirmationEmailOffWarningPaid": "You will find reservation details on the resident pages. Payment confirmation will always be sent to email."
  },
  "success": {
    "title": "Reservation successful!"
  },
  "payment": {
    "succeeded": "Paying reservation succeeded!",
    "failed": "Paying reservation failed!",
    "failedMessage": "Please try again or contact customer service.",
    "singleReservation": "Single reservation"
  },
  "error": {
    "reservationFailed": "Reservation failed. Please try again in a moment.",
    "overlap": "The selected reservation conflicts with an existing reservation. Choose another time or cancel the current reservation.",
    "contractEndDate": "The reservation time cannot be after the contract end date.",
    "contractEndDateStart": "The reservation cannot start after the contract end date.",
    "contractEndBeforeReservationStart": "The contract end date is before the selected reservation start.",
    "reservationEndBeforeStart": "The reservation end date must be the same as or later than the start date.",
    "reservationStartBeforeContractStart": "The reservation cannot start before the contract start date.",
    "contractContinuousNotAllowed": "An open-ended reservation cannot be made for a contract that has an end date.",
    "maxReservedSlotsPerWeek": "The contract's weekly reservation limit has been exceeded.",
    "invalidSlotGridPosition": "The reservation slots are not at valid times.",
    "conflict": "The reservation could not be made for the selected slot. Choose another time or contact customer service.",
    "slotAlreadyStarted": "Cannot reserve a time slot that has already started.",
    "commonError": "An error occurred, please try again later.",
    "reloadButton": "Reload",
    "oops": "Oops"
  },
  "cancelModal": {
    "title": "Reservation details",
    "recurringWarning": "This is a recurring reservation. Canceling this reservation will also cancel all future reservations in the series.",
    "terminateWarning": "Ending the reservation will remove all reservations from this date onward.",
    "effectiveFrom": "Change takes effect: {{date}}",
    "recurringInfo": "Recurring {{weekday}} at {{timeRange}}, from {{date}}",
    "singleNotAllowed": "You cannot cancel this reservation. Please contact customer service.",
    "sameDayNotAllowed": "You cannot cancel a same-day reservation",
    "terminateSameDayNotAllowed": "A recurring reservation cannot be ended on the same day.",
    "cancelFailed": "Cancelling the reservation failed. Please try again later.",
    "recurringCancelNotAllowed": "A recurring reservation cannot be cancelled after it has already started.",
    "notAllowed": "Not Allowed",
    "cancel": "Cancel",
    "confirmSingle": "Cancel Reservation",
    "confirmRecurring": "Cancel Reservations",
    "confirmTerminate": "End Reservation",
    "successSingle": "Reservation cancelled",
    "successRecurring": "Reservations cancelled",
    "successTerminated": "Reservation ended",
    "contractTerminated": "The reservation cannot be cancelled or ended because the contract has been terminated.",
    "reservationTitle": "Reservation details"
  },
  "legend": {
    "freeSlot": "Free slot",
    "reservedSlot": "Reserved slot",
    "ownReservation": "Own reservation",
    "ownSingleReservation": "Own single reservation"
  },
  "timeFormatting": {
    "everyWeek": "every week",
    "atTime": "at",
    "weekdayWithTimeRange": "{{weekday}} {{timeRange}}",
    "weekdayDateWithTimeRange": "{{weekday}} {{date}} {{timeRange}}",
    "dateWithTimeRange": "{{date}} {{timeRange}}",
    "startingFrom": "starting from",
    "beginningFrom": "Starting from:",
    "priceAddedToContract": "will be added to your contract",
    "recurringType": "Regular slot",
    "singleType": "Single slot",
    "recurringCancelled": "Regular slot cancelled",
    "recurringTerminated": "Regular slot ended",
    "singleCancelled": "Single slot cancelled",
    "hasCancelled": "has been cancelled",
    "hasTerminated": "has ended",
    "recurringUnitPrice": "Price {{price}}€/pcs/month",
    "singleUnitPrice": "Price {{price}}€/reservation",
    "upcomingRecurringUnitPrice": "New price {{price}}€/pcs/month starting from {{date}}.",
    "priceAddedToContractFromDate": "will be added to your contract starting from {{date}}.",
    "payOn3rdParty": "will be paid on third-party service"
  },
  "weekdays": {
    "monday": "Mon",
    "tuesday": "Tue",
    "wednesday": "Wed",
    "thursday": "Thu",
    "friday": "Fri",
    "saturday": "Sat",
    "sunday": "Sun"
  },
  "equipmentCategories": {
    "washing_machine": "Washing Machine",
    "allergy_washing_machine": "Allergy Washing Machine",
    "dryer": "Dryer",
    "mangle": "Mangle"
  },
  "filters": {
    "allEquipment": "All Equipment",
    "laundryRoom": "Laundry Room",
    "washingMachines": "Washing Machines",
    "dryers": "Dryers",
    "allSaunas": "All Saunas",
    "sauna": "Saunas",
    "mangles": "Mangles"
  },
  "myReservations": "My Reservations",
  "pageTitle": "Laundry Reservations",
  "pageTitleSauna": "Sauna Reservations",
  "pageTitleGym": "Gym Reservations",
  "pageTitleCommonAreas": "Common areas",
  "commonAreaSidebarDescription": "Here you can view common area reservations and book your own by selecting a free time",
  "noCalendarsAvailable": "No reservation calendars available for the selected week",
  "noReservableEquipment": "No reservable equipment",
  "saunaSidebarDescription": "Here you can view sauna slots and book your own by selecting a free time or pressing Reserve",
  "gymSidebarDescription": "Here you can view gym slots and book your own by selecting a free time",
  "pincode": "PIN code: {{pincode}}",
  "loadingPincode": "Loading PIN code...",
  "pincodeLoadError": "Failed to load PIN code"
}
